module.exports = __webpack_public_path__ + "app-static/img/03.92f69bf5.jpg";